var map = {
	"./decidim/avatar-multiuser.png": 5081,
	"./decidim/brands/google.svg": 9012,
	"./decidim/cc-badge.png": 8991,
	"./decidim/decidim-logo.svg": 5515,
	"./decidim/default-avatar.svg": 1967,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 8613,
	"./decidim/icons.svg": 4318,
	"./decidim/pattern.png": 6893,
	"./decidim/placeholder-card-g.svg": 2466,
	"./decidim/placeholder-card-l.svg": 4121,
	"./decidim/placeholder.jpg": 344,
	"./decidim/remixicon.symbol.svg": 8938,
	"./decidim/vendor/leaflet/layers-2x.png": 5447,
	"./decidim/vendor/leaflet/layers.png": 7774,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 4003,
	"./decidim/vendor/leaflet/marker-icon.png": 6090,
	"./decidim/vendor/leaflet/marker-shadow.png": 7625,
	"./decidim/vendor/social-share-button/douban.svg": 4029,
	"./decidim/vendor/social-share-button/email.svg": 6030,
	"./decidim/vendor/social-share-button/facebook.svg": 2822,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 2298,
	"./decidim/vendor/social-share-button/hacker_news.svg": 6286,
	"./decidim/vendor/social-share-button/linkedin.svg": 9316,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 13,
	"./decidim/vendor/social-share-button/pinterest.svg": 1192,
	"./decidim/vendor/social-share-button/reddit.svg": 1122,
	"./decidim/vendor/social-share-button/telegram.svg": 819,
	"./decidim/vendor/social-share-button/tumblr.svg": 4944,
	"./decidim/vendor/social-share-button/twitter.svg": 7571,
	"./decidim/vendor/social-share-button/vkontakte.svg": 5673,
	"./decidim/vendor/social-share-button/wechat.svg": 3948,
	"./decidim/vendor/social-share-button/whatsapp.svg": 7748,
	"./decidim/vendor/social-share-button/x.svg": 5830,
	"./decidim/vendor/social-share-button/xing.svg": 2690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5460;